const NUMBER_OF_BRICKS_TO_HAVE_LAST_BRICKS = 1000;
class CrowdfundingProperty {
    id;
    address;
    backyardSize;
    bricksAvailable;
    capRate;
    commercialValue;
    createdAt;
    crowdfundingPeriods;
    deliveryEndingDate;
    deliveryStartingDate;
    description;
    developer;
    estimatedCapitalGain;
    estimatedLeasingPerBrick;
    hasTraderBricks;
    highlights;
    investmentStrategy;
    isActive;
    landSize;
    maximumBricksToBuy;
    minimumBricksToBuy;
    name;
    numberOfBathrooms;
    numberOfBricks;
    numberOfUnits;
    operatorId;
    parkingLotSpaces;
    petitionerId;
    photos;
    presalePrice;
    reservedBricks;
    retailPrice;
    revolvingFundContributionPerBrick;
    riskLevel;
    status;
    targetAmount;
    thumbnailURI;
    totalEstimatedLeasing;
    type;
    vestedAmount;
    videoURL;
    yearOfConstruction;
    yearsToSale;
    constructor(data) {
        this.id = data.id;
        this.address = data.address;
        this.backyardSize = data.backyardSize;
        this.bricksAvailable = data.bricksAvailable;
        this.capRate = data.capRate;
        this.commercialValue = data.commercialValue;
        this.capRate = data.capRate;
        this.createdAt = data.createdAt;
        this.crowdfundingPeriods = data.crowdfundingPeriods;
        this.deliveryEndingDate = data.deliveryEndingDate;
        this.deliveryStartingDate = data.deliveryStartingDate;
        this.description = data.description;
        this.developer = data.developer;
        this.estimatedCapitalGain = data.estimatedCapitalGain;
        this.estimatedLeasingPerBrick = data.estimatedLeasingPerBrick;
        this.hasTraderBricks = data.hasTraderBricks;
        this.highlights = data.highlights;
        this.investmentStrategy = data.investmentStrategy;
        this.isActive = data.isActive;
        this.landSize = data.landSize;
        this.maximumBricksToBuy = data.maximumBricksToBuy;
        this.minimumBricksToBuy = data.minimumBricksToBuy;
        this.name = data.name;
        this.numberOfBathrooms = data.numberOfBathrooms;
        this.numberOfBricks = data.numberOfBricks;
        this.numberOfUnits = data.numberOfUnits;
        this.operatorId = data.operatorId;
        this.parkingLotSpaces = data.parkingLotSpaces;
        this.petitionerId = data.petitionerId;
        this.photos = data.photos;
        this.presalePrice = data.presalePrice;
        this.reservedBricks = data.reservedBricks;
        this.retailPrice = data.retailPrice;
        this.revolvingFundContributionPerBrick = data.revolvingFundContributionPerBrick;
        this.riskLevel = data.riskLevel;
        this.status = data.status;
        this.targetAmount = data.targetAmount;
        this.thumbnailURI = data.thumbnailURI;
        this.totalEstimatedLeasing = data.totalEstimatedLeasing;
        this.type = data.type;
        this.vestedAmount = data.vestedAmount;
        this.videoURL = data.videoURL;
        this.yearOfConstruction = data.yearOfConstruction;
        this.yearsToSale = data.yearsToSale;
    }
    hasLastBricks() {
        return Boolean(this.bricksAvailable > 0 && this.bricksAvailable < NUMBER_OF_BRICKS_TO_HAVE_LAST_BRICKS);
    }
}
export default CrowdfundingProperty;
